import React from 'react';

const PressLink = props =>
  <a
    rel="noopener"
    target="_blank"
    href="https://press.depop.com"
    {...props}>
    Press
  </a>;

export default PressLink;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/PressLink.js